
import { BaseModel } from '../../../../../../core/_base/crud';
import { Time } from '@angular/common';

export class BOM extends BaseModel{
    public static DEFAULT__GIAIDOAN_BTP = 2;
    public static DEFAULT__KHOILUONGCANTINH = 100;

    IdBOM : number
    MaBOM : string
    MaBOMOld : string
    TenBOM : string
    NgayTao : string
    NguoiTao : number
    TenNguoiTao : string
    TrangThaiCode : string
    TrangThaiName : string
    IdQTSX : number
    MaQTSX : number
    IdThanhPham : number
    MaThanhPham : string
    TenThanhPham : string
    DongSanPham : number
    LanBanHanh : number
    NgayBanHanh : string
    ListNPL : BOMCt[]
    TreeBTP : TreeBTP
    clear(){
        this.IdBOM  = 0
        this.MaBOM  = ""
        this.TenBOM  = ""
        this.NgayTao  = ""
        this.NguoiTao  = 0
        this.TenNguoiTao  = ""
        this.TrangThaiCode  = ""
        this.TrangThaiName  = ""
        this.IdQTSX  = 0
        this.MaQTSX  = 0
        this.IdThanhPham  = 0
        this.MaThanhPham  = ""
        this.TenThanhPham  = ""
        this.DongSanPham  = 0
        this.LanBanHanh  = 1
        this.NgayBanHanh  = ""
        this.ListNPL = []
        this.TreeBTP = new TreeBTP()
        this.MaBOMOld = ""
    }

    copy(item: BOM){
        this.IdBOM  = item.IdBOM
        this.MaBOM  = item.MaBOM
        this.TenBOM  = item.TenBOM
        this.NgayTao  = item.NgayTao
        this.NguoiTao  = item.NguoiTao
        this.TenNguoiTao  = item.TenNguoiTao
        this.TrangThaiCode  = item.TrangThaiCode
        this.TrangThaiName  = item.TrangThaiName
        this.IdQTSX  = item.IdQTSX
        this.MaQTSX  = item.MaQTSX
        this.IdThanhPham  = item.IdThanhPham
        this.MaThanhPham  = item.MaThanhPham
        this.TenThanhPham  = item.TenThanhPham
        this.DongSanPham  = item.DongSanPham
        this.LanBanHanh  = item.LanBanHanh
        this.NgayBanHanh  = item.NgayBanHanh
        this.ListNPL = item.ListNPL
        this.TreeBTP = item.TreeBTP
        this.MaBOMOld = item.MaBOMOld
    }
}

export class BOMCt extends BaseModel{
    Id : number
    BOMId : number
    IdNL : number
    MaNL : string
    TenNL : string
    IsNLC : boolean
    HieuSuatNLTruocTron : number
    TyLeTronMe : number
    LaBTP : boolean // null là Không là BTP - false: là BTP không BOM - true: là BTP có BOM
    ThuocBTP : number
    AcceptDelete: boolean // LaBTP = false => AcceptDelete = true |  LaBTP = true => AcceptDelete = false
    ListHH: any[]
    ListGroupHH: any[]
    ListHieuSuat: number[]
    KhoiLuongCanSX100: number
    clear(){
        this.Id = 0
        this.BOMId = 0
        this.IdNL = 0
        this.MaNL = ""
        this.TenNL = ""
        this.IsNLC = false
        this.HieuSuatNLTruocTron = 0
        this.TyLeTronMe = 0
        this.LaBTP = null
        this.ThuocBTP = 0
        this.AcceptDelete = true
        this.ListHH = []
        this.ListGroupHH = []
        this.ListHieuSuat = []
        this.KhoiLuongCanSX100 = 0
    }

    copy(item: BOMCt){
        this.Id = item.Id
        this.BOMId = item.BOMId
        this.IdNL = item.IdNL
        this.MaNL = item.MaNL
        this.TenNL = item.TenNL
        this.IsNLC = item.IsNLC
        this.HieuSuatNLTruocTron = item.HieuSuatNLTruocTron
        this.TyLeTronMe = item.TyLeTronMe
        this.LaBTP = item.LaBTP
        this.ThuocBTP = item.ThuocBTP
        this.AcceptDelete = item.AcceptDelete
        this.ListHH = []
        this.ListGroupHH = item.ListGroupHH
        this.ListHieuSuat = item.ListHieuSuat
        this.KhoiLuongCanSX100 = item.KhoiLuongCanSX100
    }
}

export class TreeBTP extends BaseModel{
    IdNLC : number
    MaNLC : string
    TenNLC : string
    IdThanhPham : number
    MaThanhPham : string
    TenThanhPham : string
    ListLoopGiaiDoan : LoopGiaiDoan[]
    clear(){
        this.IdNLC = 0
        this.MaNLC = ""
        this.TenNLC = ""
        this.IdThanhPham = 0
        this.MaThanhPham = ""
        this.TenThanhPham = ""
        this.ListLoopGiaiDoan = []
    }
}

export class LoopGiaiDoan extends BaseModel{
    Id: number
    BOMId: number
    HieuSuat : number
    IdGiaiDoan : number
    TenGiaiDoan: string
    IdBTP : number
    MaBTP : string
    TenBTP : string
    clear(){
        this.HieuSuat = 0
        this.IdGiaiDoan = 0
        this.IdBTP = 0
        this.MaBTP = ""
        this.TenBTP = ""
        this.Id = 0
        this.BOMId = 0
        this.TenGiaiDoan = ""
    }
}

export class __DEFAULT__IDLOAIHH{
    public static NGUYENLIEU = 1;
    public static PHULIEU = 2;
    public static THANHPHAM = 4;
    public static BANTHANHPHAM = 5;
    public static BAOBI = 6;
}

export class __DEFAULT__DSP{
    public static AD_FD = 1;
    public static VIEN = 2;
    public static HON_HOP = 3;
    public static BAN_THANH_PHAM = 4;

    public static AD_FD_NAME = "AD/FD";
    public static VIEN_NAME = "VIÊN";
    public static HON_HOP_NAME = "HỖN HỢP";

    public static LIST_DSP = [
        {
            ID   : __DEFAULT__DSP.AD_FD,
            NAME : __DEFAULT__DSP.AD_FD_NAME
        },
        {
            ID   : __DEFAULT__DSP.VIEN,
            NAME : __DEFAULT__DSP.VIEN_NAME
        },
        {
            ID   : __DEFAULT__DSP.HON_HOP,
            NAME : __DEFAULT__DSP.HON_HOP_NAME
        },
        {
            ID   : 0,
            NAME : "KHÁC"
        }
    ];
}

export class ListStep3 extends BaseModel{
    IdKV : number
    MaKV : string
    TenKV : string
    DisplayColumnsExtends : DisplayColumnsExtend[]
    DisplayColumnsExtendsString : string[]
    DataColumns : any[];
    clear(){
        this.IdKV = 0
        this.MaKV = ""
        this.TenKV = ""
        this.DisplayColumnsExtends = []
        this.DisplayColumnsExtendsString = []
        this.DataColumns = []
    }
}

export class DisplayColumnsExtend{
    name: string
    displayName: string
    IdThietBi: number

    constructor(__name: string = "",
        __displayName: string = "",
        __idThietBi: number = 0) {
		this.name = __name;
        this.displayName = __displayName;
        this.IdThietBi = __idThietBi;
	}
}

export class ListBTPStep3 extends BaseModel{
   IdBTP : number
   MaBTP : string
   TenBTP : string
   ListDetails : ListDetail[]
}

export class ListDetail extends BaseModel{
    IdCongDoan : number
    IdPhanXuong : number
    ListThietBi : ListThietBi[]
    clear(){
        this.IdCongDoan = 0;
        this.IdPhanXuong = 0;
        this.ListThietBi = []
    }
}

export class ListThietBi extends BaseModel{
    IdThietBi: number
    TenThietBi: string
    clear(){
        this.IdThietBi = 0;
        this.TenThietBi = "";
    }
}

export const StateBOM = [
	{
		id: 1,
		name: 'Đang soạn thảo',
		value: 'BOM_DANGSOANTHAO',
	},
	{
		id: 2,
		name: 'Chờ xem xét',
		value: 'BOM_CHOXACNHAN',
	},
	{
		id: 3,
		name: 'Từ chối',
		value: 'BOM_TUCHOIXACNHAN',
	},
	{
		id: 4,
		name: 'Chờ duyệt',
		value: 'BOM_CHODUYET',
	},
	{
		id: 5,
		name: 'Đang áp dụng',
		value: 'BOM_DANGAPDUNG',
	},
	{
		id: 6,
		name: 'Từ chối duyệt',
		value: 'BOM_TUCHOIDUYET',
	},
	{
		id: 7,
		name: 'Đã hủy',
		value: 'BOM_DAHUY',
	},
	{
		id: 8,
		name: 'Đã xóa',
		value: 'BOM_DAXOA',
	},
	{
		id: 9,
		name: 'Đã thay thế',
		value: 'BOM_DATHAYTHE',
	},
	{
		id: 10,
		name: 'Chờ GĐK duyệt',
		value: 'BOM_CHOGDKDUYET',
	},
	{
		id: 11,
		name: 'Từ chối duyệt',
		value: 'BOM_TUCHOIGDK',
	},
];
